import React, { useState, useEffect } from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import Select, { components } from "react-select";
import ServiceSearchRdv from "./ServiceSearchRdv/ServiceSearchRdv";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import "./ModalRdv.css";
import moment from "moment";
import { formatAnalyseToObject } from "../../utils/utils";
import Navbar from "../Navbar/Navbar";
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);
const ModalRdv = (props) => {
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const data = [{ label: "A domicile" }, { label: "Sur place" }];
  const [type, setType] = useState("");
  const { show, Toggle, date, hour, history, idPlan } = props;

  const user = {
    id: JSON.parse(sessionStorage.getItem("user")).id,
    username: JSON.parse(sessionStorage.getItem("user")).username,
  };

  const analyse = JSON.parse(sessionStorage.getItem("analyse"));
  const analysePostIds = JSON.parse(sessionStorage.getItem("analyseIds"));
  const plan = { id: idPlan };

  // added
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [typeC, setTaypeCs] = useState(
    JSON.parse(sessionStorage.getItem("Type")) &&
      JSON.parse(sessionStorage.getItem("Type")).type
  );
  const [persCharge, setPersCharge] = useState("");
  useEffect(() => {
    setPersCharge(sessionStorage.getItem("personAcharge"));
  });

  const handleClose = () => {
    setOpen(false);
    // props.Toggle();
  };

  const HandelClick = () => {
    ServiceSearchRdv.postrendezvous(
      type,
      date,
      hour,
      persCharge,
      user,
      //analyseIds,
      plan,
      analysePostIds
    ).then((res) => {
      //console.log(res.data);

      if (
        res.data.message.toString() ===
        "Rendez-vous bien enregistrée veuillez consulter votre email!"
      ) {
        setMessage(res.data.message);
        setSeverity("success");
        setOpen(true);
        window.location.replace("/pageend");
      } else if (
        res.data.message.toString() ===
        "Rendez-vous déja pris pour cette date, essayer avec une nouvelle date!"
      ) {
        setMessage(res.data.message);
        setSeverity("error");
        setOpen(true);
      }
      if (
        res.data.message.toString() ===
        "Cette heure est saturée, essayer avec une autre heure!"
      ) {
        setMessage(res.data.message);
        setSeverity("warning");
        setOpen(true);
      }
    });
  };

  // console.log(
  //   "this is object to sent back : ",
  //   type,
  //   date,
  //   hour,
  //   user,
  //   analysePostIds
  // );

  return (
    <>
      <Navbar />
      <Snackbar open={open} autoHideDuration={40000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>

      <Modal show={show} onHide={Toggle}>
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={() => {
              setType("");
              props.Toggle();
            }}
          />
          <h6
            style={{
              marginTop: "27px",
              marginBottom: "18px",
              textAlign: "center",
            }}
          >
            Vous voulez un prélèvement à domicile ou sur place?
          </h6>
          <Select
            className="input-field"
            width="90%"
            styles={{
              singleValue: (base) => ({
                ...base,
                padding: 5,
                borderRadius: 5,
                background: typeC === "Covid" ? "#c4e538" : "#2ecc71",
                color: "white",
                display: "flex",
              }),
            }}
            components={{ SingleValue }}
            isSearchable
            isClearable
            name="label"
            options={data}
            onChange={(type) => {
              type && setType(type.label);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          {type === "Sur place" && date ? (
            <>
              <p
                style={{
                  width: "100%",
                  textAlign: "center",
                  color: "red",
                  fontWeight: "bold",
                }}
              >{`Vous avez choisi le ${moment(date).format(
                "DD-MM-YYYY"
              )} à ${hour}`}</p>
              <button
                className="btn2 home buttonModal"
                onClick={() => HandelClick()}
                style={{
                  marginRight: "155px",
                  width: "200px",
                  background: typeC === "Covid" ? "#c4e538" : "#2ecc71",
                }}
              >
                Prenez Rendez-Vous
              </button>
            </>
          ) : type === "A domicile" ? (
            <Alert className="m-auto" variant="info">
              Contactez-nous pour réserver un rendez-vous!
            </Alert>
          ) : (
            ""
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalRdv;
